/** Resolved by Vite at build time; overridden in Jest via `moduleNameMapper`. */
export function getViteAppName(): string {
  return import.meta.env.VITE_APP_NAME;
}
